import { render, staticRenderFns } from "./cModalDetKar.vue?vue&type=template&id=882cc2c6&scoped=true"
import script from "./cModalDetKar.vue?vue&type=script&lang=js"
export * from "./cModalDetKar.vue?vue&type=script&lang=js"
import style0 from "./cModalDetKar.vue?vue&type=style&index=0&id=882cc2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882cc2c6",
  null
  
)

export default component.exports